import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getSocket } from '../socket';
import { playSound } from '../utils/soundAlerts';

// ── 스토리지 파일위치 공유 실시간 알림 ────────────────────────────────
// Storage.js에서 누군가 나에게 파일/폴더 위치를 공유하면(backend/routes/storage.js의
// POST /storage/share가 'storage:shared' 이벤트를 내 개인 소켓 room(user:<아이디>)으로
// 쏴준다), 지금 어느 화면을 보고 있든 간단한 토스트로 알려준다. 업무요청 알림
// (TaskRequestAlert.js)과 동일한 소켓 room 패턴을 재사용하되, 보류/이력추적 없이
// 훨씬 단순한 확인/이동 2버튼 토스트로 구성한다.
export default function StorageShareAlert() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [incoming, setIncoming] = useState(null); // { fileName, isDir, folderPath, sharedByName, sharedAt } | null

  useEffect(() => {
    if (!user) return;
    const socket = getSocket();
    if (!socket) return;

    const onShared = (payload) => {
      if (document.fullscreenElement) return; // 생산전광판 전체화면 중에는 방해하지 않음
      setIncoming(payload);
      playSound('task');
    };
    socket.on('storage:shared', onShared);
    return () => socket.off('storage:shared', onShared);
  }, [user]);

  if (!incoming) return null;

  // "스토리지로 이동" — Storage.js가 이미 쓰고 있는 activityOpen.subType 라우터 state
  // 클릭-이동 메커니즘을 그대로 재사용한다(공유된 항목이 있는 폴더로 바로 이동).
  const goToStorage = () => {
    const folderPath = incoming.folderPath || '';
    setIncoming(null);
    navigate('/storage', { state: { activityOpen: { subType: folderPath } } });
  };

  return (
    <div style={{ position:'fixed', right:24, bottom:24, zIndex:3000, width:340, maxWidth:'90vw',
      background:'#fff', borderRadius:12, boxShadow:'0 8px 28px rgba(0,0,0,0.18)', padding:'16px 18px',
      border:'1px solid #ede9fe' }}>
      <div style={{ fontSize:12.5, fontWeight:700, color:'#7C3AED', marginBottom:6 }}>
        📁 파일위치가 공유되었습니다
      </div>
      <div style={{ fontSize:14, fontWeight:600, color:'#1a1a1a', marginBottom:4,
        display:'flex', alignItems:'center', gap:6 }}>
        {incoming.isDir ? '📁' : '📄'} {incoming.fileName}
      </div>
      <div style={{ fontSize:12.5, color:'#666', marginBottom:14 }}>
        {incoming.sharedByName}님이 공유했습니다
      </div>
      <div style={{ display:'flex', gap:8 }}>
        <button onClick={goToStorage}
          style={{ flex:1, padding:'9px', background:'#7C3AED', color:'#fff', border:'none',
            borderRadius:8, fontSize:12.5, fontWeight:700, cursor:'pointer' }}>
          스토리지로 이동
        </button>
        <button onClick={() => setIncoming(null)}
          style={{ flex:1, padding:'9px', background:'#fff', color:'#555', border:'1px solid #ddd',
            borderRadius:8, fontSize:12.5, fontWeight:600, cursor:'pointer' }}>
          확인
        </button>
      </div>
    </div>
  );
}
